export default "__VITE_ASSET__GCSyF2RF__"